import BovineIcon from '@src/icons/BovineIcon'
import NonHumanPrimateIcon from '@src/icons/NonHumanPrimateIcon'
import CanineIcon from '@src/icons/CanineIcon'
import EquineIcon from '@src/icons/EquineIcon'
import FelineIcon from '@src/icons/FelineIcon'
import HumanIcon from '@src/icons/HumanIcon'
import MouseIcon from '@src/icons/MouseIcon'
import PorcineIcon from '@src/icons/PorcineIcon'
import RatIcon from '@src/icons/RatIcon'
import ChickenIcon from '@src/icons/ChickenIcon'
import OvineIcon from '@src/icons/OvineIcon'

interface IconMapProps {
  iconName: string | null | undefined
}

const IconMap: React.FC<IconMapProps> = ({ iconName }) => {
  const ICON_MAP = {
    Bovine: <BovineIcon />,
    Canine: <CanineIcon />,
    Equine: <EquineIcon />,
    Feline: <FelineIcon />,
    Human: <HumanIcon />,
    Mouse: <MouseIcon />,
    Porcine: <PorcineIcon />,
    'Non-Human Primate': <NonHumanPrimateIcon />,
    Ovine: <OvineIcon />,
    Rat: <RatIcon />,
    Chicken: <ChickenIcon />,
  }
  return <>{ICON_MAP[iconName || '']}</>
}
export default IconMap
